// extracted by mini-css-extract-plugin
export default {"toast":"VerifyEmail-module__toast___2_cBi","checkmark":"VerifyEmail-module__checkmark___2Ioil"};